"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gualdo": {
    "883a64dd": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34e9ca99": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-bartolotti": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1a6728f2": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "contro": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c693ea9": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "fanelli": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa3cce33": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "marchesi": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e768aac1": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "massignano": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40374afb": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "morrone": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b04f88c9": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "picacchi": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c0a0b872": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "scarchi": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d29e5ea3": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "tomassucci": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "710d8f50": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "807d8e32": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "zazza": [{
      "hkey": "84e0d5df",
      "slug": "gualdo",
      "name": "Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;